<template>
  <div class="why-us-section shade-section">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="row why-us-content">
            <div class="col-md-12 mb-4">
              <h3>{{ $t('string.why_us') }}</h3>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div
                  class="col-12"
                  :key="key"
                  v-for="(textItem, key) in textItems"
                >
                  <home-why-us-text-item :text-item="textItem" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 why-us-img">
          <template v-if="image">
            <img
              :src="`${baseUrl}/${image}`"
              alt="why_us.jpg"
            >
          </template>
          <template v-else>
            <img
              src="/img/background/why_us.jpg"
              alt="why_us.jpg"
            >
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeWhyUsTextItem from '@/views/includes/home/includes/HomeWhyUsTextItem'

export default {
  name: 'HomeWhyUsSection',
  components: { HomeWhyUsTextItem },
  data () {
    return {
      textItems: [
        {
          title: 'label.fast',
          icon: '/img/icons/fast.svg',
          description: 'why_us.desc.step1'
        },
        {
          title: 'label.easy',
          icon: '/img/icons/easy.svg',
          description: 'why_us.desc.step2'
        },
        {
          title: 'label.reliable',
          icon: '/img/icons/trust.svg',
          description: 'why_us.desc.step3'
        }
      ],
      baseUrl: process.env.VUE_APP_BASE_URL,
      image: ''
    }
  },
  mounted () {
    this.getWhyUsImage()
  },
  methods: {
    getWhyUsImage () {
      this.$axios.post(this.baseUrl + '/api/v4/frontend/why-us-image')
        .then(({ data }) => {
          if (data.data) {
            this.image = data.data.image
          }
        })
    }
  }
}
</script>

<style scoped>

.why-us-content {
  padding: 55px 15px;
}

.why-us-img img {
  width: 100%;
}

@media screen and (max-width: 1200px) {
  .why-us-content {
    padding: 34px 15px;
  }

  .why-us-img {
    text-align: center;
  }
  .why-us-img img {
    width: 100%;
  }
}

@media screen and (max-width: 991.89px) {
  .why-us-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 55px 15px 35px;
  }
}

@media screen and (max-width: 767px) {
  .why-us-img {
    padding: 0 !important;
  }
}
</style>
